import { IsArray, IsOptional, IsString } from 'class-validator';

import { PaginationOptionsDto } from '../../pagination-options-types';

export class GetAdminAgentDirectReferralsDto extends PaginationOptionsDto {
  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  countryCodes?: string[];
}

export class AdminAgentDirectReferralDto {
  id: string;
  alias: string;
  email: string;
  isAgent: boolean;
  referralDepth: number;
  createdAt: string;
}

export class AdminAgentDirectReferralsResponseDto {
  items: AdminAgentDirectReferralDto[];
  totalCount: number;
}
